import * as node from '../node/index-generate.js';

export default {
    node
};
